export class CollectingPayment {
    public supplierID: string;
    public orderID: number;
}
